import { EllipsisVerticalIcon } from 'lucide-react';
import { icons } from '../assets/icons';
import { useProfile } from '../hooks/queries/useMe';
import { getDeviceOS } from '../utils/deviceInfo';
import { getAuthToken } from '../lib/client';

const Header = ({
  title,
  // showBorder = false,
  showBackButton = false,
  onBackClick,
  showRightButton = false,
  onRightButtonClick,
}: {
  title?: string;
  showBorder?: boolean;
  showBackButton?: boolean;
  onBackClick?: () => void;
  showRightButton?: boolean;
  onRightButtonClick?: () => void;
}) => {
  const token = getAuthToken();
  const isAuthenticated = !!token;
  const { data: user } = useProfile(isAuthenticated);
  const ios_installed = user?.ios_installed;
  const android_installed = user?.android_installed;
  const deviceOs = getDeviceOS();

  const shouldShowPing = (deviceOs === 'ios' && !ios_installed) || (deviceOs === 'android' && !android_installed)

  return (
    <header className={`fixed top-0 left-0 right-0 z-10 bg-white border-none`}>
      <div className="w-full max-w-screen-md mx-auto py-3.5 px-4 flex justify-between items-center">
        {showBackButton && (
          <button onClick={() => onBackClick && onBackClick()}>
            <img src={icons.chevronLeft} alt="back" className="w-6 h-6" />
          </button>
        )}
        <h1 className="font-bold text-lg text-gray-800 truncate">{title}</h1>
        {showRightButton ? (
          <button className='w-6 h-6 relative' onClick={() => onRightButtonClick && onRightButtonClick()}>
            <EllipsisVerticalIcon className="w-6 h-6 text-gray-500" />
            {shouldShowPing && isAuthenticated && <div className='absolute -top-1 -right-1'><span className="relative flex size-2.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75"></span>
              <span className="relative inline-flex size-2.5 rounded-full bg-red-600"></span>
            </span></div>}
          </button>
        ) : (
          <div className="w-6 h-6" />
        )}
      </div>
    </header>
  );
};

export default Header; 
